{
  "instances": {
    "jolokia": {
      "label": "JMX",
      "close": "닫기",
      "domains": "도메인",
      "execute": "실행",
      "executing": "실행 중...",
      "execution_failed": "실행 실패.",
      "execution_successful": "실행 성공.",
      "mbeans": "MBeans"
    }
  }
}
